import {omit} from 'lodash';

import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {CardNoteModel} from '../../../models/api/cardNoteModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {CardNotesActionsEnum} from './cardNotesActions';

const cardNotesUpdatedReducer = createResourcesUpdatedReducer('cardNotes', (cardNote) => cardNote.id);

export function cardNotesReducer(
  state: ResourceMap<CardNoteModel>,
  action: AppAction,
): ResourceMap<CardNoteModel> {
  switch (action.type) {
    // Data Group.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return cardNotesUpdatedReducer(state, action);

    case CardNotesActionsEnum.NOTE_DELETED:
      return omit(state, action.payload.note.id);

    default:
      return state;
  }
}
